import { render } from "./EyeShaping.vue?vue&type=template&id=0389ef77"
import script from "./EyeShaping.vue?vue&type=script&lang=js"
export * from "./EyeShaping.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/drgeramiclinic-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__